export const taxonomy_keys = [
  'taxonomy_source',
  // Rank level keys.. These typically represent kingdom, phylum, ..., species.
  // The human-readable labels are supplied by the backend and depend on the
  // selected taxonomy.
  'r1',
  'r2',
  'r3',
  'r4',
  'r5',
  'r6',
  'r7',
  'r8',
]
export const taxonomy_ranks = taxonomy_keys.slice(1)

export const metaxaAmpliconStringMatch = 'metaxa'
